import React from 'react'

import { Text } from '@wartek-id/text-v1'
import { Checkbox, CheckboxGroup } from '@wartek-id/checkbox-v1'

import type { TResponseSuccessGetContentSearchFilterResult } from 'types/content-search'

interface SearchFilterBodyProps {
  selectedFormats: string[]
  selectedTopics: string[]
  onFormatsChange: (formats: string[]) => void
  onTopicsChange: (topics: string[]) => void
  onCheckboxChange: (isChecked: boolean, key: string) => void
  searchFiltersData:
    | TResponseSuccessGetContentSearchFilterResult
    | Record<string, never>
}

const SearchFilterBody = ({
  selectedFormats,
  selectedTopics,
  onFormatsChange,
  onTopicsChange,
  onCheckboxChange,
  searchFiltersData,
}: SearchFilterBodyProps) => {
  return (
    <>
      {Boolean(searchFiltersData?.formats) && (
        <div className="pb-6 mb-6 border-b border-subdued">
          <Text variant="heading-sm" className="mb-4">
            {searchFiltersData?.formats?.header}
          </Text>
          <CheckboxGroup
            name="select-formats"
            className="gap-y-3"
            style={{ flexDirection: 'column' }}
            value={selectedFormats}
            onChange={onFormatsChange}
          >
            {(searchFiltersData?.formats?.filter ?? []).map(
              ({ key, label }) => (
                <Checkbox
                  key={`search-filter-format-${key
                    .toLowerCase()
                    .replace(/\s/g, '-')}`}
                  className="!items-center"
                  value={key}
                  onChange={(e) => onCheckboxChange(e?.target?.checked, key)}
                >
                  {label}
                </Checkbox>
              )
            )}
          </CheckboxGroup>
        </div>
      )}

      {Boolean(searchFiltersData?.topics) && (
        <div>
          <Text variant="heading-sm" className="mb-4">
            {searchFiltersData?.topics?.header}
          </Text>
          <CheckboxGroup
            name="select-topics"
            className="gap-y-3"
            style={{ flexDirection: 'column' }}
            value={selectedTopics}
            onChange={onTopicsChange}
          >
            {(searchFiltersData?.topics?.subfilter ?? []).map((subfilter) => (
              <>
                <Text
                  variant="subheading"
                  color="subdued"
                  className="!uppercase"
                >
                  {subfilter?.title}
                </Text>

                {(subfilter?.filter ?? []).map(({ key, label }) => (
                  <Checkbox
                    key={`search-filter-topic-${key
                      .toLowerCase()
                      .replace(/\s/g, '-')}`}
                    className="!items-center"
                    value={key}
                    onChange={(e) => onCheckboxChange(e?.target?.checked, key)}
                  >
                    {label}
                  </Checkbox>
                ))}

                <div className="mb-1 leading-none"></div>
              </>
            ))}
          </CheckboxGroup>
        </div>
      )}
    </>
  )
}

export default SearchFilterBody
